import { APP, PLACES } from "../../constants";

const defaultState = APP.defaultState;

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case PLACES.FETCH:
            return { ...defaultState, isLoading: true };

        case PLACES.FETCH_SUCCESS:
            return { ...defaultState, result: action.payload };

        case PLACES.FETCH_FAILURE:
            return { ...defaultState, error: action.payload };

        default:
            return state;
    }
}
